export const BLOG_IMAGES = {
    quality: {
        src: '/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp',
        alt: 'Контроль качества банковских выписок с проверкой периодов, наложений и проблемных файлов',
        caption: 'Контроль качества выписок помогает быстро увидеть наложения периодов, проблемные файлы и участки, требующие внимания до начала глубокой аналитики.',
    },
    operationTypes: {
        src: '/assets/blog/10-minutes/oboroty-po-tipam-operaciy.webp',
        alt: 'График оборотов по типам операций в ФинРадар',
        caption: 'Обороты по типам операций помогают быстро увидеть, из каких категорий складывается движение денег и где стоит искать нетипичную активность.',
    },
    firstCheckOperationTypes: {
        src: '/assets/blog/10-minutes/oboroty-po-tipam-operaciy.webp',
        alt: 'Обороты и структура операций по типам транзакций в ФинРадаре',
        caption: 'Обороты по типам операций помогают быстро увидеть поступления, платежи, нетто-оборот и категории транзакций, которые требуют отдельной проверки.',
    },
    counterparties: {
        src: '/assets/blog/10-minutes/analiz-oborotov-po-kontragentam.webp',
        alt: 'Анализ оборотов по контрагентам и концентрации денежных потоков',
        caption: 'Разрез по контрагентам показывает, на ком концентрируется основной поток операций и какие участники формируют существенную долю оборота.',
    },
    risks: {
        src: '/assets/blog/10-minutes/riski-po-kontragentam.webp',
        alt: 'Анализ рисков по контрагентам и организации, требующие особого внимания',
        caption: 'ФинРадар помогает быстро выделить контрагентов, требующих особого внимания: например, с признаками банкротства, массового адреса, ликвидации или других риск-факторов.',
    },
    register: {
        src: '/assets/blog/10-minutes/reestr-operaciy-po-bankovskoy-vypiske.webp',
        alt: 'Реестр операций по банковской выписке с суммами, контрагентами и назначением платежей',
        caption: 'Реестр операций позволяет быстро перейти от файла к анализу: смотреть даты, суммы, контрагентов, назначения платежей, типы транзакций и фильтровать массив.',
    },
    upload: {
        src: '/assets/blog/10-minutes/zagruzka-bankovskih-vypisok.webp',
        alt: 'Загрузка банковских выписок в ФинРадар для последующего анализа',
        caption: 'Загрузка выписок в ФинРадар: можно добавить несколько файлов в проект и начать анализ в одном рабочем контуре.',
    },
    registration: {
        src: '/assets/blog/first-check/forma-registracii-finradar.webp',
        alt: 'Форма регистрации в ФинРадаре для начала первой проверки банковских выписок',
        caption: 'Регистрация в ФинРадаре: после создания аккаунта можно сразу перейти к первой проверке банковских выписок.',
    },
    projectsDashboard: {
        src: '/assets/blog/first-check/glavnyy-ekran-proektov-finradar.webp',
        alt: 'Главный экран ФинРадара с актуальными проектами и кнопкой создания нового проекта',
        caption: 'На главном экране можно открыть существующий проект или создать новый для проверки компании, ИП, физического лица или группы компаний.',
    },
    createProject: {
        src: '/assets/blog/first-check/sozdanie-proekta-analiza.webp',
        alt: 'Создание нового проекта анализа в ФинРадаре с названием проекта и ИНН объекта анализа',
        caption: 'Создание проекта: укажите название и ИНН объекта анализа, чтобы ФинРадар корректно связал выписки с владельцем счета.',
    },
    firstCheckUpload: {
        src: '/assets/blog/10-minutes/zagruzka-bankovskih-vypisok.webp',
        alt: 'Экран загрузки банковских выписок в ФинРадар с несколькими файлами проекта',
        caption: 'Загрузите одну или несколько выписок. Новые файлы можно добавлять в проект по мере поступления.',
    },
    firstCheckQuality: {
        src: '/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp',
        alt: 'Контроль качества загруженных банковских выписок в ФинРадаре с проверкой периодов и наложений',
        caption: 'Контроль качества помогает увидеть проблемные выписки, наложения периодов, разрывы и файлы в обработке.',
    },
    paymentsRegisterFilters: {
        src: '/assets/blog/first-check/filtry-reestra-platezhey.webp',
        alt: 'Фильтры реестра платежей в ФинРадаре для анализа банковских операций',
        caption: 'В реестре платежей и в отчетах ФинРадара можно фильтровать операции по периоду, контрагентам, выпискам, суммам, типам транзакций, назначениям платежей и другим параметрам.',
    },
    firstCheckCounterparties: {
        src: '/assets/blog/first-check/oboroty-po-kontragentam.webp',
        alt: 'Обороты по контрагентам и клиентские метрики в ФинРадаре',
        caption: 'Обороты по контрагентам показывают концентрацию денежных потоков и помогают быстро выделить ключевых участников движения денег.',
    },
    counterpartyReportWord: {
        src: '/assets/blog/first-check/otchet-po-kontragentu-word.webp',
        alt: 'Отчет по контрагенту в ФинРадаре с расчетами по периодам и типами транзакций',
        caption: 'Отчет по контрагенту помогает отдельно разобрать расчеты, типы операций, периоды и долю конкретного участника в общем денежном потоке. Его можно использовать онлайн и можно выгрузить из ФинРадара в Word.',
    },
    personalLoans: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/analiz-zaymov-i-kreditov-fizicheskogo-lica.webp',
        alt: 'Анализ банковской выписки физического лица при банкротстве в ФинРадаре',
        caption: 'Анализ выписки физического лица в ФинРадаре показывает, какие займы и кредиты брал гражданин за нужный промежуток времени.',
    },
    personalExtraIncome: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/regulyarnye-postupleniya-pomimo-zarplaty.webp',
        alt: 'Регулярные поступления на счет физического лица помимо заработной платы',
        caption: 'Регулярные поступления помимо зарплаты могут указывать на дополнительные источники дохода.',
    },
    personalCashWithdrawals: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/krupnye-snyatiya-nalichnyh-posle-kredita.webp',
        alt: 'Крупные снятия наличных после поступления кредитных средств',
        caption: 'Крупные снятия после поступления кредита требуют отдельного объяснения и документов.',
    },
    personalFamilyTransfers: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/perevody-rodstvennikam-i-blizkim-licam.webp',
        alt: 'Переводы родственникам и близким лицам в банковской выписке физического лица',
        caption: 'Переводы родственникам и близким лицам нужно оценивать с учетом семейного контекста и фактического назначения средств.',
    },
    personalLuxurySpending: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/dorogostoyashchie-pokupki-fizicheskogo-lica.webp',
        alt: 'Дорогостоящие покупки физического лица, не сопоставимые с заявленным доходом',
        caption: 'Дорогие покупки стоит сопоставлять с заявленным доходом и финансовым состоянием должника.',
    },
    personalBusinessTransit: {
        src: '/assets/blog/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica/perevod-kreditnyh-sredstv-yuridicheskomu-licu.webp',
        alt: 'Перевод кредитных средств на счет контролируемого юридического лица',
        caption: 'Перевод кредитных средств в контролируемый бизнес может быть важным сигналом для проверки цели кредита.',
    },
};
